module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div data-id=\"")
    ; __append(escapeFn( filter.id ))
    ; __append("\" class=\"")
    ; __append(escapeFn( filter.class ))
    ; __append(" period\">\n    <span class=\"title\">")
    ; __append(escapeFn( filter.title ))
    ; __append("</span>\n\n    <div class=\"clearfix\">\n        <div>\n            <label style=\"width: 31px;display: inline-block;\">С</label>\n            <span style=\"display: inline-block;\">\n                <control ")
    ; __append( Html.attributes(filter.from) )
    ; __append(" />\n            </span>\n        </div>\n        <div>\n            <label style=\"width: 31px;display: inline-block;\">По</label>\n            <span style=\"display: inline-block;\">\n                <control ")
    ; __append( Html.attributes(filter.to) )
    ; __append(" />\n            </span>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}